import { render, staticRenderFns } from "./workspaces.vue?vue&type=template&id=bfdf3f98"
import script from "./workspace.js?vue&type=script&lang=js&external"
export * from "./workspace.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports